import styled from 'styled-components'

import { features } from '@h2/components/media'
import { vagRundFont, base } from '@h2/components/mixins'
import { PB40T } from '@h2/components/colors'
import { Flex } from '@h2/components/layout/flex'

const ContentWrap = styled(Flex)`
  height: 100%;
  flex-direction: column;

  > h2 {
    font-size: 24px;
    line-height: 28px;
  }

  > ul {
    flex-direction: column;
  }

  @media (${features.minWidth.laptop}) {
    > h2 {
      font-size: 30px;
      line-height: 34px;
    }

    > ul {
      flex-direction: row;
    }
  }
`
const OptionBody = styled.div`
  ${base};
  display: flex;
  flex: 1;
  width: 100%;
  align-items: center;
  gap: 15px;
  padding: 10px;

  > span[role='img'] {
    cursor: pointer;
    align-self: flex-start;
  }

  > span.flex {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 5px;

    > span:first-child {
      ${vagRundFont};
      font-size: 20px;
      font-weight: 400;
      word-break: break-word;
      letter-spacing: 0.6px;
    }

    > span:last-child {
      font-size: 14px;
      font-weight: 300;
      color: ${PB40T};
    }
  }

  @media (${features.minWidth.laptop}) {
    flex-direction: column;
    gap: 5px;
    padding: 20px 10px;

    > span[role='img'] {
      align-self: auto;
    }

    > span.flex {
      display: contents;
      text-align: center;
    }
  }
`
const EmailForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;

  > div:last-child {
    margin: 35px 0;

    > div:first-child {
      margin-left: 0;
      width: 100%;
    }
  }

  @media (${features.minWidth.laptop}) {
    > div:last-child {
      margin-top: auto;
      margin-bottom: 0;

      > div:first-child {
        margin-left: auto;
        width: 250px;
      }
    }
  }
`
const dobForm = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;

  > div:last-child {
    margin: 35px 0;

    > div:first-child {
      margin-left: 0;
      width: 100%;
    }
  }

  @media (${features.minWidth.laptop}) {
    > div:last-child {
      margin-top: auto;
      margin-bottom: 0;

      > div:first-child {
        margin-left: auto;
        width: 250px;
      }
    }
  }
`

export { ContentWrap, OptionBody, EmailForm, dobForm }
